import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, ScreenHeader, EmptyState } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";
import { questionById, t } from "../content";

export default function ExamReview() {
  const { i } = useParams();
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { state } = useAppState();
  const exam = state.exams[parseInt(i || "0", 10)];

  if (!exam || !exam.answers || exam.answers.length === 0) {
    return (
      <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surface }}>
        <ScreenHeader title={tr("examReview")} onBack={() => navigate(-1)} />
        <EmptyState icon="cap" title={tr("noExamsYet")} />
      </View>
    );
  }

  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={exam.title} subtitle={`${exam.correct}/${exam.total} · ${exam.score}%`} onBack={() => navigate(-1)} />
      <View style={{ padding: 20 }}>
        {exam.answers.map((ans, idx) => {
          const q = questionById(ans.qid);
          if (!q) return null;
          return (
            <Card key={idx} style={{ marginBottom: 14 }}>
              <View row style={{ alignItems: "center", gap: 8, marginBottom: 10 }}>
                <View style={{ width: 26, height: 26, borderRadius: 13, backgroundColor: ans.correct ? colors.successSurface : colors.errorSurface, alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name={ans.correct ? "check" : "x-circle"} size={16} color={ans.correct ? colors.success : colors.error} weight={ans.correct ? "bold" : "fill"} />
                </View>
                <Text style={{ fontWeight: fonts.bold, fontSize: 12, color: colors.muted }}>{tr("question")} {idx + 1}</Text>
              </View>
              {q.scenario && <Text style={{ fontWeight: fonts.regular, fontSize: 13, lineHeight: "20px", color: colors.muted, marginBottom: 8 }}>{t(q.scenario, lang)}</Text>}
              <Text style={{ fontWeight: fonts.semibold, fontSize: 15, lineHeight: "22px", color: colors.onSurface, marginBottom: 12 }}>{t(q.prompt, lang)}</Text>
              <View style={{ gap: 8 }}>
                {q.options.map((o) => {
                  const isCorrect = q.correct.includes(o.id);
                  const isSelected = ans.selected.includes(o.id);
                  const bg = isCorrect ? colors.successSurface : isSelected ? colors.errorSurface : colors.surfaceSecondary;
                  const border = isCorrect ? colors.success : isSelected ? colors.error : colors.border;
                  return (
                    <View key={o.id} row style={{ alignItems: "center", gap: 8, backgroundColor: bg, border: `1px solid ${border}`, borderRadius: 12, padding: 10 }}>
                      {isCorrect ? <Icon name="check-circle" size={16} color={colors.success} weight="fill" />
                        : isSelected ? <Icon name="x-circle" size={16} color={colors.error} weight="fill" />
                        : <View style={{ width: 16 }} />}
                      <Text style={{ flex: 1, fontWeight: fonts.medium, fontSize: 13, lineHeight: "19px", color: colors.onSurface }}>{t(o.text, lang)}</Text>
                    </View>
                  );
                })}
              </View>
              <View style={{ backgroundColor: colors.brandTertiary, borderRadius: 12, padding: 12, marginTop: 12 }}>
                <View row style={{ alignItems: "center", gap: 6, marginBottom: 4 }}>
                  <Icon name="lightbulb" size={16} color={colors.brandPrimary} weight="fill" />
                  <Text style={{ fontWeight: fonts.bold, fontSize: 12, color: colors.brandPrimary }}>{lang === "de" ? "Erklärung" : "Explanation"}</Text>
                </View>
                <Text style={{ fontWeight: fonts.regular, fontSize: 13, lineHeight: "20px", color: colors.onSurface }}>{t(q.explanation, lang)}</Text>
              </View>
            </Card>
          );
        })}
      </View>
    </View>
  );
}
